export const ROUTE = 'checkout/contacts/ROUTE';
export const route = () => ({
  type: ROUTE,
});
